// Central place to define which `roleid` can access which admin routes.
// NOTE: Path keys are relative to `/main/` (for example: "customers/all").
const ADMIN_ROLES = [1, 3];
const VIEWER_ROLES = [2];
const SUPER_ADMIN_ROLES = [1];

export const routeRoleMap = {
  // Shared routes
  "dashboard": [...ADMIN_ROLES, ...VIEWER_ROLES],
  "profile": [...ADMIN_ROLES, ...VIEWER_ROLES],

  // Vendor admin (role 3) operational routes + super admin
  "bookings/all": [...ADMIN_ROLES, ...VIEWER_ROLES],
  "bookings/upcoming": [...ADMIN_ROLES, ...VIEWER_ROLES],
  "bookings/live": [...ADMIN_ROLES, ...VIEWER_ROLES],
  "bookings/endedtrips": ADMIN_ROLES,
  "bookings/rejected": ADMIN_ROLES,
  "bookings/cancelled": ADMIN_ROLES,
  "bookings/failed": ADMIN_ROLES,
  "bookings/history": ADMIN_ROLES,
  "bookings/completetrip": ADMIN_ROLES,
  "bookings/totalearnings": ADMIN_ROLES,
  "vehicles/pause": ADMIN_ROLES,
  "vehicles/list": ADMIN_ROLES,
  "vehicles/verify": ADMIN_ROLES,
  "vehicles/approval": ADMIN_ROLES,
  "vehicles/assigngps": ADMIN_ROLES,
  "vehicles/blocked": ADMIN_ROLES,
  "vehicles/pricingconsole": [...ADMIN_ROLES, ...VIEWER_ROLES],

  // Super-admin-only routes
  "preregistered": SUPER_ADMIN_ROLES,
  "customers/all": ADMIN_ROLES,
  "customers/blocked": SUPER_ADMIN_ROLES,
  "host/approve": SUPER_ADMIN_ROLES,
  "host/vehiclepricing": SUPER_ADMIN_ROLES,
  "host/details": SUPER_ADMIN_ROLES,
  "host/blocked": SUPER_ADMIN_ROLES,
  "host/hostpayouts": SUPER_ADMIN_ROLES,
  "host/offers": SUPER_ADMIN_ROLES,
  "host/summary": SUPER_ADMIN_ROLES,
  "bookings/hosttimings": SUPER_ADMIN_ROLES,
  "agent/all": SUPER_ADMIN_ROLES,
  "agent/payments": SUPER_ADMIN_ROLES,
  "vendor/add": SUPER_ADMIN_ROLES,
  "vendor/bulk-vehicles": SUPER_ADMIN_ROLES,
  "payments/totalearnings": SUPER_ADMIN_ROLES,
  "payments/hostearnings": SUPER_ADMIN_ROLES,
  "payments/refunds": SUPER_ADMIN_ROLES,
  "support/livechat": SUPER_ADMIN_ROLES,
  "support/mechanic": SUPER_ADMIN_ROLES,
  "complaints": SUPER_ADMIN_ROLES,
  "vadmin/vehiclemake": SUPER_ADMIN_ROLES,
  "vadmin/vehiclemodel": SUPER_ADMIN_ROLES,
  "vadmin/vehiclecategory": SUPER_ADMIN_ROLES,
  "vadmin/vehiclefueltype": SUPER_ADMIN_ROLES,
  "vadmin/vehiclefeatures": SUPER_ADMIN_ROLES,
  "vadmin/vehicletransmission": SUPER_ADMIN_ROLES,
  "vadmin/cities": SUPER_ADMIN_ROLES,
  "aadmin/coupons": SUPER_ADMIN_ROLES,
  "aadmin/referral": SUPER_ADMIN_ROLES,
  "aadmin/create-admin": SUPER_ADMIN_ROLES,
  "aadmin/protectionplans": SUPER_ADMIN_ROLES,
};
